import React from 'react';

export const ModalContext = React.createContext({
	idCounter: 0,
	modals: [],
	dialogs: [],
	showModal: _ => 0,
	showError: _ => {},
	showMessage: () => {},
	showDirtyStateModal: () => {},
	showTutorial: () => {},
	closeTutorial: () => {},
	closeModal: (modalId, closeType, modalData) => {},
	closeAll: () => {},
});
